<template><section><nav v-if="$route.query.scope === 'management' || $route.query.scope === 'legacy'" class="task-entry-nav"><router-link class="btn" to="/task-monitor">统一任务总览与监控</router-link><router-link class="btn" to="/cases">网格案例与任务分配</router-link></nav>
  <experiment-management v-if="$route.query.scope === 'management'" />
  <legacy-experiments v-else-if="$route.query.scope === 'legacy'" />
  <div v-else class="lab-empty policy-task-moved">政策任务已迁移到任务案例库。<router-link class="btn primary small" :to="{ path: '/cases', query: { module: 'policy', view: 'custom' } }">进入任务案例库</router-link></div>
</section></template>
<script>
import ExperimentManagement from './ExperimentManagement.vue'
import LegacyExperiments from './LegacyExperiments.vue'
export default { name: 'Experiments', components: { ExperimentManagement, LegacyExperiments } }
</script>
